module.exports = __webpack_public_path__ + "media/reviews-guidelines-modal-graphic.39dc86ad761c58ab9f8f3d012a68e971.svg";